var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilter = function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.496 19.082q-.498 0-.835-.337a1.13 1.13 0 0 1-.338-.832v-7.01L.517 2.255Q.077 1.67.386 1.029.694.386 1.456.386h16.427q.763 0 1.072.643.306.642-.133 1.227l-6.806 8.646v7.011q0 .496-.336.832a1.14 1.14 0 0 1-.837.337zm1.174-8.997 5.808-7.362H3.862z"
  })));
};
export default SvgFilter;